import React from 'react';
import DOMPurify from 'dompurify';
import { Request } from '../classes/Request';
import { NewClassRequest } from '../classes/NewClassRequest';
import { NotificationManager } from 'react-notifications';
import { Button, Modal } from 'react-bootstrap';

export const initForm = {
  password: '',
  password_confirmation: '',
  email: '',
  regime: '',
};

/**********************************************************FORGOT PASSWORD************************************************************************/
// ###REFACTORIZADA
export const register = async (form, recaptcha, setErrors, setForm) => {
  if (recaptcha && recaptcha.trim().length > 0) {
    if (form.password.length < 8) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: ['La contraseña debe tener al menos 8 caracteres.'],
      }));
    }
    if (!/[A-Z]/.test(form.password)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: ['La contraseña debe contener al menos una letra mayúscula.'],
      }));
    }
    if (!/[a-z]/.test(form.password)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: ['La contraseña debe contener al menos una letra minúscula.'],
      }));
    }
    if (!/[0-9]/.test(form.password)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: ['La contraseña debe contener al menos un número.'],
      }));
    }
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(form.password)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: ['La contraseña debe contener al menos un carácter especial.'],
      }));
    }

    if (form.password !== form.confirm_password) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        confirm_password: ['Las contraseñas no coinciden.'],
      }));
    }

    const request = new NewClassRequest(
      `${process.env.REACT_APP_URL_API_LARAVEL}/auth`,
      'post',
      null,
      {
        ...form,
      }
    );
    const validateRegister = await request.executeRequest();

    if (validateRegister.code !== 200) {
      if (
        validateRegister.response.message &&
        typeof validateRegister.response.message === 'object'
      ) {
        setErrors(validateRegister.response.message);
        NotificationManager.error(
          'Existen errores que impiden continuar, revisa los campos marcados en rojo.'
        );
      }
      return false;
    } else if (validateRegister.code === 200) {
      if (validateRegister.response.error) {
        setErrors(validateRegister.response.message);
        NotificationManager.error(
          'Existen errores que impiden continuar, revisa los campos marcados en rojo.'
        );
        return false;
      } else {
        return validateRegister.response.message;
      }
    }
  } else {
    const errors = {
      recaptcha: ['Este campo es obligatorio'],
    };
    setErrors(errors);
    return false;
  }
};

/**********************************************************FORGOT PASSWORD************************************************************************/
/**
 * Function to get terms and conditions of use.
 * @returns {Promise<{code: *, message: *}|any>}
 */
export const termsRequest = async (setTermsTitle, setTermsText, setCanShowModal) => {
  const request = new Request(
    `${process.env.REACT_APP_URL_API_LARAVEL}/terms/conditions?token=${process.env.REACT_APP_TOKEN}`,
    'get',
    null,
    {}
  );
  const termsRequestData = await request.executeRequest(false);
  if (termsRequestData.code === 200) {
    //MOSTRAR ALERTA EXITOSA CON EL MENSAJE QUE RETORNA LA API COMPONENTE
    setTermsTitle(termsRequestData.data.data.data.content.title);
    setTermsText(termsRequestData.data.data.data.content.description);
  } else {
    setCanShowModal(false);
  }
};
/***************************************************************************************************************************************************/

export const ModalTermsAndConditions = (show, setHandleTermsModal, termsText, termsTitle) => {
  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          setHandleTermsModal(false);
        }}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>{termsTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(termsText) }}
            style={{ maxHeight: '60vh', overflowY: 'scroll' }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
              setHandleTermsModal(false);
            }}
          >
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
